<template>
  <div id="wizardPage7" ref="wizardPage7">
    <div v-if="!ledgerRowId && resolutionError">
      <b-alert variant="warning" show>
        <div class="text-dark">{{ resolutionError }}</div>
      </b-alert>
    </div>
    <div v-else-if="!ledgerRowId && !transactionId">
      <p class="text-muted mb-0">
        Billing processing is unavailable until a ledger row can be resolved for this transaction.
      </p>
    </div>
    <billing-processing-panel
      v-else
      :ledger-row-id="ledgerRowId"
      :transaction-id="transactionId"
      :resolution-error="resolutionError"
    />
  </div>
</template>

<script>
import BillingProcessingPanel from "@/view/pages/billing/BillingProcessingPanel.vue";

/**
 * Wizard step 7 — Processing and Finalisation.
 * Thin wrapper: posting gates stay inside PostingRail / BillingProcessingPanel.
 * No ValidationObserver — leave/next is never blocked by this page.
 */
export default {
  name: "ProcessingFinalisationPage",

  components: {
    BillingProcessingPanel
  },

  props: {
    ledgerRowId: {
      type: String,
      default: null
    },
    transactionId: {
      type: String,
      default: null
    },
    resolutionError: {
      type: String,
      default: null
    }
  }
};
</script>
